module.exports = ".stop {\n    background: url(https://d2zmbkdpl0cf9q.cloudfront.net/../assets/icons/new/STOP.svg) center center no-repeat;\n}\n\n@media screen and (max-width: 640px) {\n\n    .wg-icon .icon.stop {\n        background-size: 30px !important;\n    }\n\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/player/stop-button/stop-button.component.css
// module id = ./src/app/player/stop-button/stop-button.component.css
// module chunks = main